module.exports = __webpack_public_path__ + "img/johnsalinas.3654153a.png";